import * as React from "react"
const StarRatingIcon = ({ color = "#554DF1", ...props }) => (
  <svg
    width={15}
    height={15}
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M14.9608 5.66765C14.862 5.3507 14.5926 5.12631 14.2751 5.09633L9.94508 4.68612L8.23382 0.505394C8.10747 0.198241 7.81999 0 7.50001 0C7.18003 0 6.89243 0.198241 6.76689 0.505394L5.05563 4.68612L0.724889 5.09633C0.407425 5.12691 0.138599 5.3513 0.0392629 5.66765C-0.0595011 5.98459 0.0317097 6.33223 0.27181 6.55197L3.54499 9.54695L2.57989 13.9825C2.50928 14.3087 2.63059 14.6459 2.88992 14.8415C3.02931 14.9472 3.19307 15 3.35741 15C3.49864 15 3.63997 14.9608 3.7662 14.882L7.50001 12.5523L11.2331 14.882C11.507 15.0528 11.8513 15.0371 12.1101 14.8415C12.3694 14.6459 12.4907 14.3087 12.4201 13.9825L11.455 9.54695L14.7282 6.55197C14.9682 6.33223 15.0595 5.98531 14.9608 5.66765Z'
      fill={color}
    />
  </svg>
)
export default StarRatingIcon
